import {UI} from "../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../stem-core/src/ui/Style";
import {styleRule} from "../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {Mark} from "../../SVGElements";


export class DropdownItemStyle extends StyleSheet {
    @styleRule
    item = {
        cursor: "pointer",
        transition: ".2s ease",
        ":hover": {
            background: this.themeProps.MERCHANT_INPUT_BACKGROUND_HOVER,
        },
        display: "flex",
        flexDirection: "row",
        ">:first-child": {
            flex: 1,
        },
        ">:nth-child(2)": {
            width: 40,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        ">:nth-child(2)>*": {
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignItems: "center",
        },
    };
}

@registerStyle(DropdownItemStyle)
export class DropdownItem extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            active: false,
            list: null,
            item: null,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.item);
    }

    render() {
        return [
            <div>{super.render()}</div>,
            <div>
                <div>{this.options.active ? <Mark size={14} testId="dropdownItemMark" /> : null}</div>
            </div>,
        ];
    }

    setActive() {
        this.options.list.dispatch("changeActive", this.options.item);
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => this.setActive());
    }
}
